<template>
  <a-card style="flex: 1;margin-left: 24px;">
    <template slot="title">
      <div style="display: flex;justify-content: space-between">
        <div>{{ $t('enterpriseUpgrading') }}</div>
        <div @click="$router.go(-1)"><dol-button><a-icon type="close" /></dol-button></div>
      </div>
    </template>
    <dol-form-model :model="editForm" :rules="validateRules" ref="editForm">
      <a-form-model-item class="company-register-form-item" :labelCol="{span: 5}" :wrapperCol="{span: 19}"
                         prop="COMPANY_NAME">
        <template slot="label">
          <span>{{ $t('通用_企业名称') }}</span>
        </template>
        <a-input v-model.trim="editForm.COMPANY_NAME" :placeholder="$t('pleaseEnterCompanyName')" disabled/>
      </a-form-model-item>
      <a-form-model-item class="company-register-form-item" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
        <template slot="label">
          <span>{{ $t('contact') }}</span>
        </template>
        <a-input v-model.trim="editForm.PERSON" :placeholder="$t('pleaseEnterTheContactPerson')"  size="large" disabled/>
      </a-form-model-item>
      <a-form-model-item class="company-register-form-item" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
        <template slot="label">
          <span>{{ $t('mobile') }}</span>
        </template>
        <a-input v-model.trim="editForm.MOBILE" :placeholder="$t('pleaseEnterMobilePhoneNumber')"  size="large" disabled/>
      </a-form-model-item>
      <a-form-model-item class="company-register-form-item" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
        <template slot="label">
          <span>{{ $t('businessAddressDetails') }}</span>
        </template>
        <a-input v-model.trim="editForm.ADDRESS" :placeholder="$t('pleaseEnterTheDetailedAddressOfTheEnterprise')"  size="large" disabled/>
        <!--            <dol-select :width="'100%'" size="large" v-model.trim:lue="editForm.username"/>-->
      </a-form-model-item>
      <a-form-model-item class="company-register-form-item" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
        <template slot="label">
          <span>{{ $t('email') }}</span>
        </template>
        <a-input v-model.trim="editForm.EMAIL" :placeholder="$t('pleaseEnterEmailAddress')"  size="large" disabled/>
      </a-form-model-item>
      <a-form-model-item class="company-register-form-item" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
        <template slot="label">
          <span>{{ $t('businessLicense') }}</span>
        </template>
        <a-space align="start">
          <dol-image-list-preview  :imageList="imgList"/>
        </a-space>
      </a-form-model-item>
      <a-form-model-item class="company-register-form-item" :labelCol="{span: 5}" :wrapperCol="{span: 19}" prop="CITY_IDS">
        <template slot="label">
          <span>{{ $t('portOfOffice') }}</span>
        </template>
        <dol-select
            size="large"
            :width="'100%'"
            v-model.trim="editForm.CITY_IDS"
            source="server"
            server-type="DotNet"
            dot-net-table-name="GM_CITY"
            label-field="CITY_NAME"
            key-field="CITY_ID"
            value-field="CITY_ID"
            mode="multiple"
        />
      </a-form-model-item>
      <a-form-model-item class="company-register-form-item" :colon="false" :labelCol="{span: 5}" :wrapperCol="{span: 24}">
        <template slot="label">
          <span style="font-weight: 600">{{ $t('bankOfDeposit') }}</span>
        </template>
        <div class="acct-bank-style" ><span class="acct-bank-style-span">{{ $t('chinaAccount') }}:</span> <a-input v-model.trim="editForm.ACCT_NO" style="width: 79%" size="large" :placeholder="$t('pleaseEnterTheBankName')" disabled /></div>
        <div class="acct-bank-style" ><span class="acct-bank-style-span">{{ $t('russiaAccount') }}:</span> <a-input v-model.trim="editForm.ACCT_NO2" style="width: 79%" size="large" :placeholder="$t('pleaseEnterTheBankName')" disabled /></div>
        <div class="acct-bank-style" ><span class="acct-bank-style-span">{{ $t('americaAccount') }}:</span> <a-input v-model.trim="editForm.ACCT_NO3" style="width: 79%" size="large" :placeholder="$t('pleaseEnterTheBankName')" disabled /></div>
      </a-form-model-item>
      <a-form-model-item class="company-register-form-item" :labelCol="{span: 5}" :wrapperCol="{span: 19}" prop="ACCT_BANK">
        <template slot="label">
          <span>{{ $t('bankName') }}</span>
        </template>
        <a-input v-model.trim="editForm.ACCT_BANK" size="large" :placeholder="$t('pleaseEnterTheBankName')" disabled/>
      </a-form-model-item>
      <a-form-model-item class="company-register-form-item" :labelCol="{span: 5}" :wrapperCol="{span: 19}" prop="ACCT_ADDRESS">
        <template slot="label">
          <span>{{ $t('bankAddress') }}</span>
        </template>
        <a-input v-model.trim="editForm.ACCT_ADDRESS" size="large" :placeholder="$t('pleaseEnterYourBankAddress')" disabled/>
      </a-form-model-item>
<!--      <a-form-model-item class="company-register-form-item" :labelCol="{span: 5}" :wrapperCol="{span: 19}" prop="ACCT_NO">-->
<!--        <template slot="label">-->
<!--          <span>银行汇款号码</span>-->
<!--        </template>-->
<!--        <a-input size="large" v-model.trim="editForm.ACCT_NO" placeholder="请输入银行汇款号码" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item class="company-register-form-item" :labelCol="{span: 5}" :wrapperCol="{span: 19} " prop="ACCT_PHONE"
                         style="margin-bottom:32px;">
        <template slot="label">
          <span>{{ $t('bankPhone') }}</span>
        </template>
        <a-input v-model.trim="editForm.ACCT_PHONE" :placeholder="$t('pleaseEnterTheBankPhoneNumber')" size="large" disabled/>
      </a-form-model-item>
      <div style="text-align: center">
        <a-button type="primary" style="background: #1F6CBA;width: 150px" @click="companyUpgrade"
                  block size="large">{{ $t('submitApplications') }}
        </a-button>
      </div>
    </dol-form-model>
  </a-card>
</template>

<script>

export default {
  name: "enterprise",
  data() {
    return {
      editForm: {
        CITY_IDS: []
      },
      validateRules: {
        CITY_IDS: [{ required: true, message: this.$t('pleaseFillInThePort'), trigger: ['blur','change'] }],
        ACCT_BANK: [{ required: true, message: this.$t('pleaseEnterTheBankName'), trigger: ['blur','change'] }],
        ACCT_ADDRESS: [{ required: true, message: this.$t('pleaseEnterYourBankAddress'), trigger: ['blur','change'] }],
        ACCT_PHONE: [{ required: true, message: this.$t('pleaseFillInTheBankPhone'), trigger: ['blur','change'] }],
        ACCT_NO: [{ required: true, message: this.$t('pleaseFillInTheBankNumber'), trigger: ['blur','change'] }],
      },
      imgList:[]
    }
  },
  computed: {
    userInfo() {
      return this.$store?.state?.userInfo;
    },
  },
  methods: {
    companyUpgrade() {
      let data = {};
      this.$refs.editForm.validate((val) => {
        data.NEW_SYS_TYPE = 20011002;
        data.ORGI_SYS_TYPE = 20011003;
        data.GUID_CODES = '';
        data.COMPANY_ID = this.$store.state?.userInfo?.COMPANY_ID;
        data.CITY_IDS = this.editForm.CITY_IDS.join(',')
        if (val) {
          this.$h5Api({
            type: '2007',
            data: [data],
            showMessage: false,
          }).then(({data, total}) => {
            this.$store.commit('afterLogin', data);
            this.$router.push('company')
          })
        }
      })
    }
  },
  created() {
    this.editForm = {
      COMPANY_ID : this.userInfo?.COMPANY_ID,
      COMPANY_NAME : this.userInfo?.COMPANY_NAME,
      PERSON : this.userInfo?.PERSON,
      MOBILE : this.userInfo?.MOBILE,
      ADDRESS : this.userInfo?.ADDRESS,
      EMAIL : this.userInfo?.EMAIL,
      ACCT_TYPE : this.userInfo?.ACCT_TYPE || 20081001,
      ACCT_BANK : this.userInfo?.ACCT_BANK,
      ACCT_ADDRESS : this.userInfo?.ACCT_ADDRESS,
      ACCT_NO : this.userInfo?.ACCT_NO,
      ACCT_NO2 : this.userInfo?.ACCT_NO2,
      ACCT_NO3 : this.userInfo?.ACCT_NO3,
      ACCT_PHONE : this.userInfo?.ACCT_PHONE
    }
    if(this.$store.state.fileList){
      this.imgList = this.$store.state.fileList;
    }
    let list = []
    if(this.userInfo.cityList.length > 0) {
      this.userInfo.cityList.forEach(item => {
        list.push(item.CITY_ID)
      })
    }
    this.$set(this.editForm,'CITY_IDS',list)
  }
}
</script>

<style scoped lang="scss">
.acct-bank-style{
  display: flex;
  justify-content: flex-end;
  .acct-bank-style-span{
    margin-right: 8px;
    color: rgba(0, 0, 0, 0.85);
  }
+ .acct-bank-style{
  margin-top: 24px;
}
}

</style>